import React from 'react';
import PageLayout from '../app/layout/PageLayout';
import EmptyState from '../components/EmptyState';
import PageMeta from '../utils/PageMeta';
import * as styles from './NotFoundView.module.scss';

interface NotFoundViewProps
  extends Partial<React.ComponentProps<typeof EmptyState>> {
  documentTitle?: string;
}

const NotFoundView = ({
  documentTitle = 'Not Found - Slab',
  ...props
}: NotFoundViewProps) => (
  <PageLayout.Content className={styles.container}>
    <PageMeta title={documentTitle} />
    <EmptyState
      imageName="notFound"
      title="Oh no! The knowledge you seek is nowhere to be found."
      {...props}
    />
  </PageLayout.Content>
);

export default NotFoundView;
